import { isSupportedDateInput } from '../../util/datetime';
import { sanitizeBindable, sanitizeBoolean, sanitizeBoundValue, sanitizeString } from './helpers';
function sanitizeDateInputArray(raw) {
  if (!Array.isArray(raw)) return undefined;
  const inputs = raw.filter(isSupportedDateInput);
  return inputs.length > 0 ? inputs : undefined;
}
export function sanitizeCalendar(el) {
  const value = sanitizeBoundValue(el.value);
  if (!value) return null;
  return {
    type: 'Calendar',
    value,
    availableDates: sanitizeBindable(el.availableDates, sanitizeDateInputArray),
    timezone: sanitizeBindable(el.timezone, sanitizeString),
    required: sanitizeBindable(el.required, sanitizeBoolean),
    disabled: sanitizeBindable(el.disabled, sanitizeBoolean)
  };
}